<div class="ot-panel" [hidden]="isImporting">
  @if (newPlan) {
  <div class="ot-panel__body ot-p-1">
    <div title="Import plan" class="otsc-settings-label" i18n-title>
      <h4 id="import-plan-title" il8n>Import plan</h4>
    </div>
    <ng-scrollbar style="height: calc(100vh - 235px);">
      <div style="width: 50%;">
        <app-plans-form [mode]="mode" [plan]="newPlan" (formEvent)="updateForm($event)"></app-plans-form>
      </div>
    </ng-scrollbar>
  </div>
  }
  @if (formGroup) {
  <div class="ot-panel__footer ot-panel__footer--is-right-justified">
    <div class="ot-btn-group">
      <button role="button" id="import-plan-import-btn" class="ot-btn ot-btn--is-primary"
        [disabled]="formGroup.pending || formGroup.invalid || isImporting" (click)="importPlan()" i18n>
        Import
      </button>
      <button role="button" id="import-plan-cancel-btn" class="ot-btn ot-btn--is-secondary" (click)="cancel()" i18n>
        Cancel
      </button>
    </div>
  </div>
  }
</div>
<div [hidden]="!isImporting" style="top: 50%;position: absolute;left: 50%;">
  <div class="ot-progress-container">
    <div class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
      <div class="ot-progress__outer">
        <div class="ot-progress__meter">
        </div>
      </div>
      <div class="ot-progress__text" i18n>Importing plan...</div>
    </div>
  </div>
</div>